import { CONFIG } from "~/config";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

interface IOptions {
	poi: any;
	routeBtnCb?: (event: MouseEvent) => void;
}

interface IOptionsPlace {
	item: any;
	routeBtnCb?: (event: MouseEvent) => void;
	url: string;
}

interface IMarkerInfo {
	info: HTMLSpanElement;
	buttonPart: HTMLSpanElement;
	seperatorPart: HTMLSpanElement;
}

function getFuel(poi: any): string {
	if (!poi.extend?.fuel) {
		return null;
	}

	const data = poi.extend.fuel.label ? poi.extend.fuel.value : poi.extend.fuel as any;
	let line = "";

	for (let index = 0; index < data.length && index < 2; index++) {
		// chtelo by prozkoumat, zda by proste jen nestacilo udelat data[i].id > 0 && data[i].id < 5
		if ([1, 2, 3, 4].indexOf(data[index].id) === -1) {
			continue;
		}

		const span = node("span", {
			innerHTML: data[index].price,
			className: `type-${data[index].id}`,
		});

		line += span.outerHTML;
	}

	return line;
}

function getAddress(poi: any) {
	let address = "";

	if (poi.multiTitle && Array.isArray(poi.multiTitle) && poi.multiTitle.length) {
		address = poi.multiTitle.slice(1).join(", ");
	} else if (poi.address && Array.isArray(poi.address)) {
		address = poi.address.join(", ");
	}

	return address;
}

/**
 * vytvoreni elementu pro kartu nad markerem, pouziva se pro markery hledani a pro marker detailu
 */
export function createMarkerInfo({
	poi = {},
	routeBtnCb = null,
}: IOptions): IMarkerInfo {
	const infoPart = node("a", {
		className: "info-part",
		href: `${CONFIG.mapyURL}/?source=${poi.source}&id=${poi.id}`,
	});
	const title = node("h5", {}, poi.title);

	infoPart.appendChild(title);

	const fuel = getFuel(poi);
	const address = getAddress(poi);

	if (!fuel && address) {
		infoPart.appendChild(node("p", { className: "address" }, address));
	}

	if (poi.extend && poi.extend.opening) {
		const actualState = poi.extend.opening.actualState;
		const actual = poi.extend.opening.actual;
		const msg = poi.extend.opening.msg; //getOpeningText(poi.extend.opening);
		const holiday = poi.extend.opening.holiday;

		let openingTxt = (actualState
			? `<span class="opening-state ${actualState.replace(/[A-Z]/u, match => `-${match.toLowerCase()}`)}"> ${poi.extend.opening.actualStateCaption}</span>`
			: poi.extend.opening.label)
				+ (actual ? ` - ${actual}` : "")
				+ (msg || holiday ? "<span class=\"holiday\">*</span>" : "");

		if ("msg" in poi.extend.opening && !poi.extend.opening.seasons.length) {
			// eslint-disable-next-line prefer-template
			openingTxt = (actualState ? `<span class="opening-state ${actualState.replace(/[A-Z]/u, match => `-${match.toLowerCase()}`)}"> ${poi.extend.opening.actualStateCaption}</span>` : poi.extend.opening.label)
				+ " - "
				+ _("detail.content.opening.seeDetail") + "<span class=\"holiday\">*</span>";
		}

		const openingEl = node("p", { innerHTML: openingTxt });

		if (msg || holiday) {
			openingEl.setAttribute("title", (msg || "") + (msg && holiday ? "\n" : "") + (holiday || ""));
		}

		infoPart.appendChild(openingEl);
	}

	if (fuel) {
		infoPart.appendChild(node("p", { className: "fuel", innerHTML: fuel }));
	}

	if (poi.inactive) {
		infoPart.appendChild(node("p", { className: "inactive", textContent: poi.temporarilyClosed ? _("detail.content.closed.temporarilyClosed") : _("detail.content.closed.title") }));
	}

	const seperatorPart = node("span", { className: "separator-part" });
	const innerSeperatorPart = node("span", { className: "separator" });
	const buttonPart = node("span", { className: "button-part" });
	const routeBtn = node("button", { innerHTML: "", type: "button" });

	seperatorPart.appendChild(innerSeperatorPart);

	buttonPart.appendChild(routeBtn);
	routeBtnCb && buttonPart.addEventListener("click", routeBtnCb);

	return {
		info: infoPart,
		buttonPart,
		seperatorPart,
	};
}

/**
 * vytvoreni elementu pro kartu nad markerem, pouziva se pro markery v moje mapy
 */
export function createMarkerInfoPlace({
	item,
	routeBtnCb,
	url,
}: IOptionsPlace): IMarkerInfo {
	const infoPart = node("a", {
		className: "info-part",
		href: url,
	});
	const title = node("h5", {}, item.usertitle || item.title);

	infoPart.appendChild(title);
	infoPart.appendChild(node("p", { className: "address" }, item.subtitle));

	const seperatorPart = node("span", { className: "separator-part" });
	const innerSeperatorPart = node("span", { className: "separator" });
	const buttonPart = node("span", { className: "button-part" });
	const routeBtn = node("button", { innerHTML: "", type: "button" });

	seperatorPart.appendChild(innerSeperatorPart);

	if (routeBtnCb) {
		buttonPart.appendChild(routeBtn);
		buttonPart.addEventListener("click", routeBtnCb);
	}

	return {
		info: infoPart,
		buttonPart,
		seperatorPart,
	};
}
